export const WITHDRAW_LIST = 'WITHDRAW_LIST';
export const WITHDRAW_BALANCE = 'WITHDRAW_BALANCE';
export const LAST_APPROVED_WITHDRAW = 'LAST_APPROVED_WITHDRAW';
export const CREATE_WITHDRAW = 'CREATE_WITHDRAW';
export const CANCEL_WITHDRAW = 'CANCEL_WITHDRAW';
export const HANDLE_INPUT = 'HANDLE_INPUT';
export const RESET_FORM_INPUT = 'RESET_FORM_INPUT';
export const SET_RESPONSE_STATUS = 'SET_RESPONSE_STATUS';
export const LOADER = 'LOADER';
export const TINY_LOADER = 'TINY_LOADER';
export const RESET_RESPONSE_STATUS = 'RESET_RESPONSE_STATUS';
export const SHOW_ALERT = 'SHOW_ALERT';
